import { cast } from 'mobx-state-tree';
import moment from 'moment';
import { timetable_timeslot_configuration } from '@app-types/graphql-types';
import { TimelineItemTypeType } from '@app-types/timetable';
import { TimetableModelType } from '../../Timetable';
import { getTimeSlotConfigurationDataForCurrentWeek } from './loadTimeSlotConfigurationFromDB/getTimeSlotConfigurationDataForCurrentWeek';
import { getDefaultTimeSlotConfigurationData } from './loadTimeSlotConfigurationFromDB/getDefaultTimeSlotConfigurationData';
import { formatDefaultTimeSlotConfigurationData } from './loadTimeSlotConfigurationFromDB/formatDefaultTimeSlotConfigurationData';
import { TimeSlotConfigurationModelType } from '../../TimeSlotConfiguration';
import { TimelineItemModelType } from '../../TimelineItem';
import { getTimeLineIntervalSlotsForAllGroups } from '../helpers/getTimeLineIntervalSlotsForAllGroups';

export const loadTimeSlotConfigurationFromDB = (self: Partial<TimetableModelType>) => {
  return function* loadTimeSlotConfigurationFromDBAsync() {
    if (
      !self.timeSlotConfigurationsLoaded &&
      !self.loadingTimeSlotConfigurations &&
      self.week &&
      self.batch &&
      self.timelineGroups &&
      self.timelineGroups?.length > 0 &&
      !self.timeSlotConfigurations
    ) {
      self.loadingTimeSlotConfigurations = true;

      // Get data for the current week
      const timeslotConfigurationData = yield getTimeSlotConfigurationDataForCurrentWeek({
        week: self.week,
        batchId: self.batch.id,
      });

      if (
        timeslotConfigurationData.data &&
        timeslotConfigurationData.data.timetable_timeslot_configuration.length > 0
      ) {
        const timeSlotConfigurations: TimeSlotConfigurationModelType[] = [];
        let timeLineIntervals: TimelineItemModelType[] = [];

        timeslotConfigurationData.data.timetable_timeslot_configuration.forEach(
          (timeSlotConfiguration: timetable_timeslot_configuration) => {
            if (!timeSlotConfiguration.interval) {
              timeSlotConfigurations.push({
                startTime: timeSlotConfiguration.startTime,
                endTime: timeSlotConfiguration.endTime,
              });
            } else if (self.timelineGroups) {
              const timeLineIntervalSlotsForAllGroups = getTimeLineIntervalSlotsForAllGroups({
                timelineGroups: self.timelineGroups,
                startTime: moment(timeSlotConfiguration.startTime),
                endTime: moment(timeSlotConfiguration.endTime),
              });

              timeLineIntervals = [...timeLineIntervals, ...timeLineIntervalSlotsForAllGroups];
            }
          },
        );

        self.timeSlotConfigurations = cast(timeSlotConfigurations);
        if (timeLineIntervals.length > 0) {
          if (self.timelineItems) {
            self.timelineItems = cast([...self.timelineItems, ...timeLineIntervals]);
          } else {
            self.timelineItems = cast(timeLineIntervals);
          }
        }
      } else {
        // Try to ge the default configurations
        const defaultTimeslotConfigurationData = yield getDefaultTimeSlotConfigurationData();

        if (
          defaultTimeslotConfigurationData.data &&
          defaultTimeslotConfigurationData.data.timetable_timeslot_configuration.length > 0
        ) {
          const { timeSlotConfigurations, timeLineIntervals } = formatDefaultTimeSlotConfigurationData({
            timeSlotConfigurations: defaultTimeslotConfigurationData.data.timetable_timeslot_configuration,
            week: self.week,
            timelineGroups: self.timelineGroups,
          });

          self.timeSlotConfigurations = cast(timeSlotConfigurations);

          const existingTimelineItemsWithoutIntervals = self.timelineItems?.filter(
            (timelineItem) => timelineItem.itemType !== TimelineItemTypeType.interval,
          );

          self.timelineItems = cast([
            ...(existingTimelineItemsWithoutIntervals as TimelineItemModelType[]),
            ...timeLineIntervals,
          ]);
        }
      }

      self.timeSlotConfigurationsLoaded = true;
      self.loadingTimeSlotConfigurations = false;
    }
  };
};
